var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBabymam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 60,
    viewBox: "0 0 129 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9650_18755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3122V47.4852C2.31181 47.7661 4.57644 47.9533 6.88825 48.0001C19.7211 48.0001 24.7222 42.2888 24.7222 35.8753C24.7694 27.4956 15.1919 23.0951 0 24.3122Z",
    fill: "url(#paint0_linear_9650_18755)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.5604 26.7297C19.3028 25.3285 19.6748 23.7897 19.7683 22.2508C19.7211 17.3605 14.2011 11.0596 0 12.1411V24.3122C7.88716 23.6803 14.261 24.5625 18.5604 26.7297Z",
    fill: "url(#paint1_linear_9650_18755)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5479 37.2001H39.6272C42.2879 37.2001 44.3438 35.5201 44.3438 33.0601C44.3438 30.5401 42.3483 29.8201 42.1468 29.7801C42.3483 29.7201 43.6182 28.9001 43.6182 27.2001C43.6182 24.2601 41.4211 23.2001 39.1233 23.2001H34.5479V37.2001ZM39.5466 34.9201H36.9666V31.2001H39.5466C40.8769 31.2001 41.8847 31.7401 41.8847 33.0601C41.8847 34.3801 40.8769 34.9201 39.5466 34.9201ZM36.9666 28.9201V25.4801H39.0427C40.2319 25.4801 41.1591 25.9801 41.1591 27.2001C41.1591 28.4201 40.3932 28.9201 39.0427 28.9201H36.9666Z",
    fill: "#6B1D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9038 35.4401C49.158 35.4401 48.1703 35.2201 48.1703 34.2201C48.1703 33.2001 49.1983 32.8801 49.9441 32.8801C51.2542 32.8801 52.121 33.3601 52.121 33.3601V34.3401C52.121 34.3401 51.355 35.4401 49.9038 35.4401ZM50.186 27.4801C48.1905 27.4801 46.4167 28.3401 46.4167 28.3401L47.2028 30.3201C47.2028 30.3201 48.6742 29.6201 50.065 29.6201C50.9116 29.6201 52.121 30.0201 52.121 31.2601V31.8001C52.121 31.8001 51.2139 31.1201 49.4603 31.1201C47.3842 31.1201 45.7113 32.4401 45.7113 34.2601C45.7113 36.2801 47.3641 37.4401 49.158 37.4401C51.3147 37.4401 52.3024 36.0001 52.3024 36.0001V37.2001H54.5397V31.0201C54.5397 28.8601 52.9272 27.4801 50.186 27.4801Z",
    fill: "#6B1D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2433 37.2001H59.4807V35.9601C59.4807 35.9601 60.3071 37.4401 62.363 37.4401C64.8422 37.4401 67.0191 35.3801 67.0191 32.4601C67.0191 29.5401 64.8422 27.4801 62.363 27.4801C60.5489 27.4801 59.6621 28.7201 59.6621 28.7201V22.0801H57.2433V37.2001ZM59.6621 31.0401C59.6621 31.0401 60.3474 29.7201 61.9397 29.7201C63.5724 29.7201 64.56 30.9001 64.56 32.4601C64.56 34.0201 63.5724 35.2001 61.9397 35.2001C60.3474 35.2001 59.6621 33.8801 59.6621 33.8801V31.0401Z",
    fill: "#6B1D66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9849 41.0401C67.9849 41.0401 69.0935 42.0401 70.5447 42.0401C71.9556 42.0401 73.3061 41.4001 74.1325 39.3201L78.7685 27.7201H76.1683L73.6488 34.6601L70.4238 27.7201H67.743L72.3991 37.4201L72.0161 38.4001C71.5525 39.5601 71.2099 39.8001 70.3835 39.8001C69.7586 39.8001 69.1136 39.1801 69.1136 39.1801L67.9849 41.0401Z",
    fill: "#6B1D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2179 23.2001V37.2001H88.6367V27.8001L93.0509 34.4601L97.4651 27.8001V37.2001H99.8839V23.2001H97.6465L93.0509 30.2401L88.4553 23.2001H86.2179Z",
    fill: "#6B1D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.337 35.4401C105.592 35.4401 104.604 35.2201 104.604 34.2201C104.604 33.2001 105.632 32.8801 106.378 32.8801C107.688 32.8801 108.555 33.3601 108.555 33.3601V34.3401C108.555 34.3401 107.789 35.4401 106.337 35.4401ZM106.62 27.4801C104.624 27.4801 102.85 28.3401 102.85 28.3401L103.636 30.3201C103.636 30.3201 105.108 29.6201 106.499 29.6201C107.345 29.6201 108.555 30.0201 108.555 31.2601V31.8001C108.555 31.8001 107.647 31.1201 105.894 31.1201C103.818 31.1201 102.145 32.4401 102.145 34.2601C102.145 36.2801 103.798 37.4401 105.592 37.4401C107.748 37.4401 108.736 36.0001 108.736 36.0001V37.2001H110.973V31.0201C110.973 28.8601 109.361 27.4801 106.62 27.4801Z",
    fill: "#6B1D66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.481 27.4801C122.243 27.4801 121.437 29.1401 121.437 29.1401C121.437 29.1401 120.772 27.4801 118.474 27.4801C116.519 27.4801 115.652 29.1001 115.652 29.1001V27.7201H113.395V37.2001H115.813V30.9401C115.813 30.9401 116.418 29.7201 117.688 29.7201C118.897 29.7201 119.401 30.4201 119.401 31.7201V37.2001H121.82V30.9401C121.82 30.9401 122.425 29.7201 123.695 29.7201C124.904 29.7201 125.408 30.4201 125.408 31.7201V37.2001H127.827V31.1001C127.827 28.8201 126.416 27.4801 124.481 27.4801Z",
    fill: "#6B1D66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9650_18755",
    x1: 0,
    y1: 36.0681,
    x2: 24.7647,
    y2: 36.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9650_18755",
    x1: 0,
    y1: 19.392,
    x2: 19.7353,
    y2: 19.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9650_18755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7694,
    height: 36,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBabymam);
export default __webpack_public_path__ + "static/media/logo-babymam.5583412da6e77c205a7bf443ed41c207.svg";
export { ForwardRef as ReactComponent };